module.exports = {
  10000: { api: '10000', human: 'Acasta European Insurance Company' },
  15000: { api: '15000', human: 'Helvetia Versicherungen' }
}
